import { injectReducers } from '../../store/reducers'
import AppLayout from '../../components/Layouts/AppLayout'
import { AsyncComponent } from '../../components/Layouts/RouterLayout'
import * as ROUTES from '../../constants/routes'

const getMessageContainer = store =>
  import(/* webpackChunkName: "Message" */ './reducers')
    .then(module => injectReducers(store, module.default))
    .then(() => import(/* webpackChunkName: "Message" */ './containers/MessageContainer'))
    .then(module => module.default)

export default (store) => ([
  {
    layout: AppLayout,
    exact: true,
    path: [
      ROUTES.MESSAGE_LIST_PATH,
      ROUTES.MESSAGE_DETAIL_PATH,
    ],
    component: AsyncComponent(() => getMessageContainer(store))
  }
])
